import { render, staticRenderFns } from "./WineCogsHistoryModal.vue?vue&type=template&id=70bceeb6&scoped=true"
import script from "./WineCogsHistoryModal.vue?vue&type=script&lang=js"
export * from "./WineCogsHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./WineCogsHistoryModal.vue?vue&type=style&index=0&id=70bceeb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bceeb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bceeb6')) {
      api.createRecord('70bceeb6', component.options)
    } else {
      api.reload('70bceeb6', component.options)
    }
    module.hot.accept("./WineCogsHistoryModal.vue?vue&type=template&id=70bceeb6&scoped=true", function () {
      api.rerender('70bceeb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineCogsHistoryModal.vue"
export default component.exports